module.exports = __webpack_public_path__ + "img/slide-non-dispo-43.bf8273f9.jpg";